import { Pipe, PipeTransform } from '@angular/core';
import { ReportsDTO } from '../admin.dto';

@Pipe({
    name: 'reportsFilter',
    pure: false,
})
export class ReportsFilterPipe implements PipeTransform {
    transform(items: ReportsDTO[], filter: Object): any {
        if (filter == 'All') {
            return items;
        }
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter((item) => item.isHandled == filter);
    }
}